import { render, staticRenderFns } from "./SettingsP2PNotificationsFilters.vue?vue&type=template&id=c9fd8cbe&scoped=true&"
import script from "./SettingsP2PNotificationsFilters.vue?vue&type=script&lang=js&"
export * from "./SettingsP2PNotificationsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fd8cbe",
  null
  
)

export default component.exports